import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./TravelTips.css";

const TravelTips = () => {
  return (
    <>
      {/* HERO */}
      <section className="tips-hero">
        <Container>
          <h1>Travelling Tips</h1>
          <p>Important information to help you enjoy a smooth and safe journey</p>
        </Container>
      </section>

      {/* CONTENT */}
      <section className="tips-section">
        <Container>
          <div className="tips-card">
            <h3>Travel alerts and information:</h3>
            <p>
              Please reach Airport on Time ( Plan for 2 Hrs Prior to departure ) ,
              Also if you are trvelling by Train please confirm its schedule and if
              it is delayed beyond 10 Hrs please inform our executive. Please note
              unutilised services can not be refunded and its difficult to shift the
              itinerary.
            </p>
          </div>

          <div className="tips-card">
            <h3>Check in time:</h3>
            <p>
              Check in time at hotels depends upon Hotel Policy , we always try to
              design itinerary so there is no waiting for check in.
            </p>
          </div>

          <div className="tips-card">
            <h3>Recommendations</h3>
            <p>
              In the majority of cases you will book a holiday and have no trouble
              whatsoever, however, on rare occasions it does / may go wrong. These
              steps will help you have a trouble free holiday.
            </p>

            <p>Please check the following before booking a holiday plan ahead</p>

            <ul>
              <li>Please let us know the motive of your travel like Relaxation , Sight seen , Leisure Time etc</li>
              <li>Do you have special dietary requirements – Vegetarian / Jain food</li>
              <li>Do inform us of any disability</li>
              <li>Do you have a medical condition that may need attention</li>
              <li>Please carry extra medicines because all medicines may not be available.</li>
              <li>Keep a set of photocopy of your travel documentation and take it with you, in case you lose the originals when on holiday.</li>
            </ul>
          </div>

          <div className="tips-card">
            <h3>General packing tips:</h3>
            <p>
              Basic personal items to be carried include, feather jacket & heavy
              woolens during winter and light woolens during summer, walking boots,
              rain proof jacket during monsoon, torch, spare batteries, water flask,
              cold cream, personal medicines & Sunglasses.
            </p>

            <p>
              Advice guest to bring heavy woolens if traveling to Lachung/North
              Sikkim as this area is cold through out the year.
            </p>
          </div>

          <div className="tips-card">
            <h3>Traveling out of country/Going Abroad Tips</h3>

            <h4>TRAVEL ESSENTIALS:</h4>

            <p>Airports Authority of India -</p>
            <a href="http://www.airportsindia.org.in/" target="_blank" rel="noreferrer">
              http://www.airportsindia.org.in/
            </a>

            <p>Ministry of Tourism, Government of India -</p>
            <a href="http://www.airportsindia.org.in/" target="_blank" rel="noreferrer">
              http://www.airportsindia.org.in/
            </a>

            <p>Airport Guide -</p>
            <a href="http://www.airportsindia.org.in/AAI/main.jsp" target="_blank" rel="noreferrer">
              http://www.airportsindia.org.in/AAI/main.jsp
            </a>

            <p>Indian Missions Abroad -</p>
            <a href="http://www.airportsindia.org.in/AAI/main.jsp" target="_blank" rel="noreferrer">
              http://www.airportsindia.org.in/AAI/main.jsp
            </a>

            <h4>Weather</h4>
            <p>Indian Meteorological Department - http://www.imd.ernet.in/</p>
            <p>Weather Forecasts - http://www.wunderground.com/</p>
          </div>
        </Container>
      </section>
    </>
  );
};

export default TravelTips;
